import { useTranslation } from 'react-i18next'

import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../../Tag'
import {
  PROVENANCE_CHIP_BACKGROUND_COLOR,
  PROVENANCE_CHIP_TEXT_COLOR,
  QA_NAME_PROVENANCE_CHIP,
} from '../RentalPortalProvenance.constants'
import { getIsProvenanceFieldPortalOwned } from '../RentalPortalProvenance.utils'

import * as styles from './RentalPortalProvenanceChip.module.css'

function RentalPortalProvenanceChip({ ownership }) {
  const { t } = useTranslation()

  return getIsProvenanceFieldPortalOwned(ownership) ? null : (
    <Tag
      appearance={TAG_APPEARANCE.filled}
      backgroundColor={PROVENANCE_CHIP_BACKGROUND_COLOR}
      className={styles.RentalPortalProvenanceChip}
      height={TAG_HEIGHT.height20}
      qaName={QA_NAME_PROVENANCE_CHIP}
      text={t('RentalPortal.ProvenanceFromSourceKey', {
        source: ownership.source_label,
      })}
      textColor={PROVENANCE_CHIP_TEXT_COLOR}
    />
  )
}

export default RentalPortalProvenanceChip
